import { FC, Suspense, lazy } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import { MasterLayout } from '../../_metronic/layout/MasterLayout'
import TopBarProgress from 'react-topbar-progress-indicator'
import { getCSSVariableValue } from '../../_metronic/assets/ts/_utils'
import { WithChildren } from '../../_metronic/helpers'
import { useAuth } from '../modules/Auth'
import { CropMonitoring } from '../modules/Tables/crop_monitoring'
import { UpdatePlan } from '../modules/Tables/update_plan'
import APIScreen from '../modules/Tables/api_hits/APIScreen'
import CustomerInteraction from '../modules/Tables/customer_interaction'
import LeadManagment from '../modules/Tables/lead_managment'
import RaiseTicket from '../modules/Tables/raise_ticket'
import UserFarmBulkUpload from '../modules/Tables/user_onboarding'
import S6ActivationDashboard from '../modules/Tables/s6_management'
import IotDeviceMapping from '../modules/Tables/iot_device_mapping'
// import FeedBack from '../modules/tables/feedback_form'


const PrivateRoutes = () => {
  const { currentUser } = useAuth()
  console.log('Current User Role:', currentUser?.role);


  return (
    <Routes>
      <Route element={<MasterLayout />}>
        {/* User Monitoring (dashboard) — ALL roles */}
        <Route path="dashboard" element={<CropMonitoring />} />

        {/* User Onboarding — Admin, Operations, Sales (NOT Agronomist) */}
        {(currentUser?.role === 'Admin' ||
          currentUser?.role === 'Operations' ||
          currentUser?.role === 'Sales') && (
            <Route path="user-onboarding" element={<UserFarmBulkUpload />} />
          )}

        {/* S6 Activation — Admin, Operations */}
        {(currentUser?.role === 'Admin' || currentUser?.role === 'Operations') && (
          <Route path="s6-activation" element={<S6ActivationDashboard />} />
        )}

        {/* IoT Device Mapping — Admin, Operations, Agronomist */}
        {(currentUser?.role === 'Admin' ||
          currentUser?.role === 'Operations' ||
          currentUser?.role === 'Agronomist') && (
            <Route path="iot-device-mapping" element={<IotDeviceMapping />} />
          )}

        {/* Update Subscription — Admin, Operations */}
        {(currentUser?.role === 'Admin' || currentUser?.role === 'Operations') && (
          <Route path="update-subscription" element={<UpdatePlan />} />
        )}

        {/* Admin-only features */}
        {currentUser?.role === 'Admin' && (
          <>
            <Route path="api-usage" element={<APIScreen />} />
            <Route path="customer-interaction" element={<CustomerInteraction />} />
            <Route path="lead-management" element={<LeadManagment />} />
            <Route path="raise-tickets" element={<RaiseTicket />} />
          </>
        )}
      </Route>

      {/* Role-based default redirect — dashboard is the one feature all 4 roles share */}
      {currentUser?.role === 'Admin' && <Route index element={<Navigate to="/dashboard" />} />}
      {currentUser?.role === 'Operations' && <Route index element={<Navigate to="/dashboard" />} />}
      {currentUser?.role === 'Sales' && <Route index element={<Navigate to="/dashboard" />} />}
      {currentUser?.role === 'Agronomist' && <Route index element={<Navigate to="/dashboard" />} />}

      <Route path="*" element={<Navigate to="/error/404" />} />
    </Routes>
  );

}

const SuspensedView: FC<WithChildren> = ({ children }) => {
  const baseColor = getCSSVariableValue('--bs-primary')
  TopBarProgress.config({
    barColors: {
      '0': baseColor,
    },
    barThickness: 1,
    shadowBlur: 5,
  })
  return <Suspense fallback={<TopBarProgress />}>{children}</Suspense>
}

export { PrivateRoutes }
